<template>
    <transition name="animate" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
        <router-view></router-view>
    </transition>
</template>
<script>
    export default {}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/informes/index.vue